/**
 * Step 1: Method Selection Component
 */

import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

export type ImportMethod = 'text' | 'csv' | 'linkedin_search' | 'sales_nav' | 'google_sheets';

interface Step1MethodSelectionProps {
  method: ImportMethod | null;
  onMethodChange: (method: ImportMethod) => void;
}

export const Step1MethodSelection: React.FC<Step1MethodSelectionProps> = ({ method, onMethodChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select how you want to import leads
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>
        <Card
          sx={{
            cursor: 'pointer',
            border: method === 'text' ? 2 : 1,
            borderColor: method === 'text' ? 'primary.main' : 'divider',
            '&:hover': { borderColor: 'primary.main' },
          }}
          onClick={() => onMethodChange('text')}
        >
          <CardContent>
            <Typography variant="h6">Paste URLs</Typography>
            <Typography variant="body2" color="text.secondary">
              Paste multiline text with LinkedIn URLs
            </Typography>
          </CardContent>
        </Card>
        <Card
          sx={{
            cursor: 'pointer',
            border: method === 'csv' ? 2 : 1,
            borderColor: method === 'csv' ? 'primary.main' : 'divider',
            '&:hover': { borderColor: 'primary.main' },
          }}
          onClick={() => onMethodChange('csv')}
        >
          <CardContent>
            <Typography variant="h6">Upload CSV</Typography>
            <Typography variant="body2" color="text.secondary">
              Upload a CSV file with LinkedIn URLs
            </Typography>
          </CardContent>
        </Card>
        <Card
          sx={{
            cursor: 'not-allowed',
            opacity: 0.5,
            border: 1,
            borderColor: 'divider',
          }}
        >
          <CardContent>
            <Typography variant="h6">LinkedIn Search</Typography>
            <Typography variant="body2" color="text.secondary">
              Coming soon
            </Typography>
          </CardContent>
        </Card>
        <Card
          sx={{
            cursor: 'not-allowed',
            opacity: 0.5,
            border: 1,
            borderColor: 'divider',
          }}
        >
          <CardContent>
            <Typography variant="h6">Sales Navigator</Typography>
            <Typography variant="body2" color="text.secondary">
              Coming soon
            </Typography>
          </CardContent>
        </Card>
        <Card
          sx={{
            cursor: 'not-allowed',
            opacity: 0.5,
            border: 1,
            borderColor: 'divider',
          }}
        >
          <CardContent>
            <Typography variant="h6">Google Sheets</Typography>
            <Typography variant="body2" color="text.secondary">
              Coming soon
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

